module.exports = require("twemoji");